import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import posthog from 'posthog-js';

import { ErrorPage } from '@/routes/(authenticated)/-components/ErrorPage';
import { logger } from '@/services/logger';

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error('Uncaught error in ErrorBoundary', error, {
      component: 'ErrorBoundary',
      metadata: errorInfo as Record<string, unknown>,
    });
    posthog.captureException(error, { component: 'ErrorBoundary' });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}
